import { SAMPLE_PROSPECTING_POST_SAMPLE_QUERY_PARAM_VALUE } from "@faire/retailer-visitor-shared/components/App/AppModals/consts";
import {
  AppSignUpModalVariant,
  isFaireDirectVariant,
} from "@faire/retailer-visitor-shared/components/AppSignUp/AppSignUpModalVariant";
import { AppSignUpQueryParams } from "@faire/retailer-visitor-shared/components/AppSignUp/AppSignUpQueryParams";
import { SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { FAIRE_DIRECT_BRAND_QUERY_PARAM } from "@faire/web--source/common/routes/faire-direct/FAIRE_DIRECT_BRAND_QUERY_PARAM";

export const buildFaireDirectParams = (
  signUpParams: AppSignUpQueryParams,
  modalVariant: AppSignUpModalVariant,
  faireDirectBrandToken: string,
  faireDirectBrandName: string | undefined,
  faireDirectBrandAlias: string
) => {
  // we want to show the widget in sign-up flow if it's coming from a sample prospecting:
  const signUpType =
    signUpParams.signUp === SAMPLE_PROSPECTING_POST_SAMPLE_QUERY_PARAM_VALUE
      ? SignUpType.WIDGET_V2
      : SignUpType.FAIRE_DIRECT;

  if (isFaireDirectVariant(modalVariant)) {
    return {
      signUp: signUpType,
      brand: faireDirectBrandToken,
      brandName: faireDirectBrandName,
      [FAIRE_DIRECT_BRAND_QUERY_PARAM]: faireDirectBrandAlias,
    };
  }

  /**
   * We do not want the `fdb` query param to be passed into the sign-up flow
   * if the modal is not a Faire Direct variant in order to prevent incorrectly
   * giving the Faire Direct credit.
   */
  return {
    [FAIRE_DIRECT_BRAND_QUERY_PARAM]: undefined,
  };
};
